import { ComponentStyleConfig } from '@chakra-ui/react'

export const FormLabel: ComponentStyleConfig = {
    baseStyle: {
        color: 'green.default',
    },
    sizes: {
        md: {
            fontWeight: 400,
            fontSize: '0.75rem',
            lineHeight: '1.25rem',
            marginBottom: '3px'
        },
    },
    defaultProps: {
        size: 'md',
    },
}
